import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { LogoVaxYes } from "../Logo";
import { makeStyles } from "@material-ui/styles";
import { themes } from "../../theme";
import { useTranslation } from "react-i18next";

const useClasses = makeStyles({
  ggvButton: {
    backgroundColor: themes.GGV.palette.primary.main,
    color: themes.GGV.palette.common.white,
    "&:hover": {
      backgroundColor: themes.GGV.palette.primary.dark
    }
  }
});

const VaxYesTeaser = () => {
  const { t } = useTranslation();
  const classes = useClasses();

  return (
    <>
      <Box textAlign="center" mb={2}>
        <LogoVaxYes height="40px" />
      </Box>
      <Typography variant="body2" paragraph>
        <strong>{t("components.vax_yes_teaser.teaser_text")}</strong>
      </Typography>
      <Button
        variant="contained"
        fullWidth
        className={classes.ggvButton}
        size="large"
        href="https://www.gogetdoc.com/vaxyes"
        target="blank"
        rel="noopener"
      >
        {t("components.vax_yes_teaser.button")}
      </Button>
    </>
  );
};

export { VaxYesTeaser };
